export default __webpack_public_path__ + "static/media/Othmane.dfcf64bc.jpg";